import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import { App } from './App.js';
import { ErrorBoundary } from './ErrorBoundary.js';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('No #root element — index.html is wrong.');
}

createRoot(container).render(
  <StrictMode>
    {/*
      D55. Firebase Hosting already rewrites ** to /index.html, so a deep link
      such as /event is served by the app rather than 404ing at the edge.
    */}
    {/*
      The last resort. Route-level boundaries contain a broken screen; this one
      exists for a failure in the shell itself, which would otherwise still
      blank the page. D57.
    */}
    <ErrorBoundary what="Cairn">
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
